<template>
  <v-carousel
    height="300"
    style="width: 976px"
    class="mb-4"
    hide-delimiter-background
    show-arrows-on-hover
  >
    <v-carousel-item
      v-for="item in items"
      :key="item.id"
      :src="item.src"
      reverse-transition="fade-transition"
      transition="fade-transition"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { id: 1, src: require("@/assets/images/banner/banner-2.jpg") },
        { id: 2, src: require("@/assets/images/banner/banner-3.jpg") },
      ],
    };
  },
};
</script>

<style lang="css" scoped>
* >>> .v-image.v-responsive.v-carousel__item.theme--light {
  border-radius: 5px;
}
.width[data-v-03188eca] {
  max-width: 976px;
}
</style>